export const ERROR_REPORTING = 'error_reporting';
